import { runAtreemoFunctions } from '../functions/atreemo';

export const enquiryForm = () => {
   const conditionalTriggers = document.querySelectorAll('.js-conditional-field-trigger');

   conditionalTriggers.forEach(trigger => {
       trigger.addEventListener('change', (e) => {
           const triggerId = trigger.closest('.js-survey-question').dataset.questionId;
           
            // Find the conditional fields
            const conditionalFields = document.querySelectorAll('.js-survey-question');
            const conditionalOptions = document.querySelectorAll('.js-conditional-field-choice');

            conditionalFields.forEach(field => {
                const fieldTriggers = field.dataset.conditionalTriggers;

                if ( fieldTriggers ) {
                    if ( fieldTriggers.includes(triggerId) ) {
                        if ( field.dataset.conditionalType === 'Show' ) {
                            if ( field.dataset.conditionalValues.includes(e.target.value) ) {
                                field.classList.remove('hidden');
                                field.querySelector('.js-survey-question-input').disabled = false;
                            } else {
                                field.classList.add('hidden');
                                field.querySelector('.js-survey-question-input').disabled = true;
                            }
                        }

                        if ( field.dataset.conditionalType === 'Hide' ) {
                            if ( field.dataset.conditionalValues.includes(e.target.value) ) {
                                field.classList.add('hidden');
                                field.querySelector('.js-survey-question-input').disabled = true;
                            } else {
                                field.classList.remove('hidden');
                                field.querySelector('.js-survey-question-input').disabled = false;
                            }
                        }
                    }
                }
            });

            conditionalOptions.forEach(option => {
                if ( option.dataset.conditionalType === 'Show' ) {
                    if ( option.dataset.conditionalValues.includes(e.target.value) ) {
                        option.classList.remove('hidden');
                        option.disabled = false;
                    } else {
                        option.classList.add('hidden');         
                        option.disabled = true;
                    }
                }

                if ( option.dataset.conditionalType === 'Hide' ) {
                    if ( option.dataset.conditionalValues.includes(e.target.value) ) {
                        option.classList.add('hidden');
                        option.disabled = true;
                    } else {
                        option.classList.remove('hidden');
                        option.disabled = false;
                    }
                }
            });
       });
   });

   const submitButton = document.querySelector('.js-enquiry-form-submit');
   const enquiryFormElem = document.getElementById('enquiry-form');

    if ( submitButton ) {
        submitButton.addEventListener('click', (event) => {
            event.preventDefault();
            
            const dropdowns = enquiryFormElem.querySelectorAll('.js-survey-question-select');

            // Clear any existing errors
            enquiryFormElem.querySelectorAll('.js-enquiry-form-error').forEach(error => {
                error.classList.add('hidden');
            });

            // Validate the form
            let isValid = true;
            
            if (enquiryFormElem.checkValidity()) {
                dropdowns.forEach(dropdown => {
                    if (!dropdown.disabled && dropdown.value === 'error') {
                        isValid = false;
                    }
                });

                if ( isValid ) {
                    // If form is valid, dispatch the submit event
                    const submitEvent = new Event('submit', {
                        bubbles: true,
                        cancelable: true
                    });
                    enquiryFormElem.dispatchEvent(submitEvent);
                } else {
                    dropdowns.forEach(dropdown => {
                        if ( dropdown.value === 'error' ) {
                            dropdown.closest('.js-survey-question').querySelector('.js-enquiry-form-error').classList.remove('hidden');
                        }
                    });
                }
            } else {
                dropdowns.forEach(dropdown => {
                    if ( dropdown.value === 'error' ) {
                        dropdown.closest('.js-survey-question').querySelector('.js-enquiry-form-error').classList.remove('hidden');
                    }
                });

                // If form is invalid, trigger browser's default validation UI
                enquiryFormElem.reportValidity();
            }
        });
    }

    if ( enquiryFormElem ) {
        enquiryFormElem.addEventListener('submit', (e) => {
            e.preventDefault();
     
            const mod = enquiryFormElem.closest('.enquiry-form');
            const formContainer = mod.querySelector('.enquiry-form__container');
            const formData = new FormData(enquiryFormElem);
    
            // Show the loader
            enquiryFormElem.classList.add('opacity-30');
            formContainer.querySelector('.js-popup-loader').classList.remove('hidden');
    
            const ajaxData = {
                action: 'ajax_atreemo_survey'
            };
    
            // loop through the form data and append to the ajax data
            for (const [key, value] of formData.entries()) {
                const question = enquiryFormElem.querySelector(`[name="${key}"]`);
                const questionType = question.classList.contains('js-survey-question-checkbox') || question.classList.contains('js-survey-question-select') ? 'NodeValue' : 'TextValue';
    
                ajaxData[questionType + '_' + key] = value;
            }
    
            // Store the ajax data
    
            // Run the atreemo functions
            runAtreemoFunctions(ajaxData).then((response) => {
                // Update the response elements
                const responseContainer = mod.querySelector('.js-enquiry-response-container');
                const responseHeading = responseContainer.querySelector('.js-enquiry-response-heading');
                const responseContent = responseContainer.querySelector('.js-enquiry-response-content');
    
                responseHeading.textContent = response.heading;
                responseContent.innerHTML = response.content;
    
                // Hide the form
                mod.querySelector('.enquiry-form__container').style = 'display: none;';
                mod.querySelector('.enquiry-form__title').classList.add('hidden');
                mod.querySelector('.enquiry-form__container').classList.remove('hidden');
    
                setTimeout(() => {
                    responseContainer.classList.remove('hidden');
                }, 1000);
            });
        });
    }
}